import channelLayoutValues from './channel-layout-values';


const ON_MOUSE_OVER = 1;
const ALWAYS = 2;
const NEVER = 3;

export const CLASSIC_SHOW_INFO_VALUES = [
  ON_MOUSE_OVER,
  ALWAYS,
];

export const STRIP_SHOW_INFO_VALUES = [
  ...CLASSIC_SHOW_INFO_VALUES,
  NEVER,
];

export const COMPACT_SHOW_INFO_VALUES = [
  ...STRIP_SHOW_INFO_VALUES,
];

export default {
  ON_MOUSE_OVER,
  ALWAYS,
  NEVER,
};

export const PER_LAYOUT_SHOW_INFO_VALUES = {
  [channelLayoutValues.CLASSIC]: CLASSIC_SHOW_INFO_VALUES,
  [channelLayoutValues.STRIP]: STRIP_SHOW_INFO_VALUES,
  [channelLayoutValues.COMPACT]: COMPACT_SHOW_INFO_VALUES,
};



// WEBPACK FOOTER //
// ./src/default-settings/show-info-values.js